import React from "react";
import { Button } from "react-bootstrap";
import { FailureIcon } from "../Global/Icons";

type ErrorProps = {
  title: string;
  text: string;
  onClose: () => void;
};

export default function ErrorDisplay({ title, text, onClose }: ErrorProps) {
  return (
    <div className="text-center py-5">
      <FailureIcon />
      <h1 className="m-0">{title}</h1>
      <p>{text}</p>
      <Button onClick={onClose}>Continue</Button>
    </div>
  );
}
